export const TIER = {
  one: 1,
  two: 2,
  three: 3
};

export const TIER_LABEL = {
  [TIER.one]: 'Tier 1',
  [TIER.two]: 'Tier 2',
  [TIER.three]: 'Tier 3'
};

export const TIER_TYPE = {
  auto: 1,
  custom: 2
};
